import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root',
})
export class GoogleMapsService {
  private apiLoaded = false;
  private autocompleteService: any;
  private isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  loadGoogleMapsApi(): Promise<void> {
    if (!this.isBrowser) return;

    return new Promise((resolve, reject) => {
      if (this.apiLoaded) {
        resolve();
        return;
      }

      if (this.isBrowser) {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&libraries=places`;
        script.async = true;
        script.defer = true;
        script.onload = () => {
          this.apiLoaded = true;
          this.autocompleteService = new google.maps.places.AutocompleteService();
          resolve();
        };
        script.onerror = () => reject('Google Maps API load error');
        document.body.appendChild(script);
      }

    });
  }

  getSuggestions(postcodeTerm: string): Promise<any[]> {
    return new Promise((resolve, reject) => {
      if (!postcodeTerm) {
        resolve([]);
        return;
      }
  
      if (!this.apiLoaded || !this.autocompleteService) {
        reject('Google Maps API is not loaded');
        return;
      }
  
      const options = {
        input: postcodeTerm,
        componentRestrictions: {
          country: 'gb',
        },
      };
  
      this.autocompleteService.getPlacePredictions(options, (results, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          resolve(results);
        } else {
          reject(`Autocomplete failed: ${status}`);
        }
      });
    });
  }

  // Geocoding function
  geocodeLatLng(lat: number, lng: number): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.apiLoaded) {
        reject('Google Maps API is not loaded');
        return;
      }

      const geocoder = new google.maps.Geocoder();
      const latLng = new google.maps.LatLng(lat, lng);
      geocoder.geocode({ location: latLng }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          resolve(results);
        } else {
          reject(`Geocode failed: ${status}`);
        }
      });
    });
  }

  getPlaceDetails(placeId: string): Promise<any> {
    if (!this.isBrowser) return;
    const service = new google.maps.places.PlacesService(document.createElement('div'));
    return new Promise((resolve, reject) => {
      service.getDetails({ placeId }, (place, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          resolve(place);
        } else {
          reject(`Place details fetch failed: ${status}`);
        }
      });
    });
  }
}
